namespace GeniuzPOS.RefundReasonReport {
    export namespace ReportRefundReasonSumBillDtService {
        export const baseUrl = 'RefundReasonReport/ReportRefundReasonSumBillDt';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportRefundReasonSumBillDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportRefundReasonSumBillDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "RefundReasonReport/ReportRefundReasonSumBillDt/Retrieve",
            List = "RefundReasonReport/ReportRefundReasonSumBillDt/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportRefundReasonSumBillDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
